import React, { FC, ReactNode } from 'react';
import { ErrorMap } from 'ia-react-core/~/interfaces/ErrorMap';
import { MessageMap } from 'ia-react-core/~/interfaces/MessageMap';

import ControlErrorMessages from '../../message/ControlErrorMessages';

export interface ControlGroupProps {
  /** The children */
  children: ReactNode;
  errors?: ErrorMap;
  warnings?: ErrorMap;
  messages?: MessageMap;
}

/**
 * @mode developer
 */
const ControlGroup: FC<ControlGroupProps> = ({ children, errors, warnings, messages }) => (
  <>
    {children}
    <ControlErrorMessages<any>
      errors={errors}
      warnings={warnings}
      messages={messages}
    />
  </>
);
ControlGroup.displayName = 'ControlGroup';

export default ControlGroup;
